// Change this file when switching router libraries (react-router -> wouter, etc.)

import {
  RouterProvider as BaseRouterProvider,
  createBrowserRouter,
  Link as RouterLink,
  Navigate as RouterNavigate,
  Outlet as RouterOutlet,
  useLocation as useRouterLocation,
  useMatches as useRouterMatches,
  useNavigate as useRouterNavigate,
  useParams as useRouterParams,
  useSearchParams as useRouterSearchParams,
} from "react-router";

export const Navigate = RouterNavigate;
export const Outlet = RouterOutlet;
export const RouterProvider = BaseRouterProvider;
export const useLocation = useRouterLocation;

export function useTypedLocation<T>() {
  const location = useRouterLocation();
  return location as Omit<typeof location, "state"> & { state: T };
}
export const useMatches = useRouterMatches;
export const useNavigate = useRouterNavigate;
export const useParams = useRouterParams;
export const useSearchParams = useRouterSearchParams;
export const Link = RouterLink;

export type { Location, NavigateFunction, Params } from "react-router";

export { RouteErrorBoundary } from "./ErrorBoundary";

export const createRouter = createBrowserRouter;
